export default "__VITE_ASSET__BB0yViZ6__"